"use client";
import type * as React from "react";
import * as Icons from "./directory";

export type IconName = keyof typeof Icons;

interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName;
  size?: number;
  color?: string;
}

export const Icon = ({ name, size = 24, color, ...props }: IconProps) => {
  const SvgIcon = Icons[name];

  return <SvgIcon width={size} height={size} {...props} />;
};
